module.exports = __webpack_public_path__ + "static/media/screenshot 2.8e42441d.jpg";